import { useApolloClient, useQuery } from '@apollo/client';
import { EledoAccount, EledoAccountData, EledoAccountInput, EledoAccountProfile, EledoAccountProfileInput, EledoAccountVars, EledoNotificationsConfig, EledoNotificationsConfigInput, GET_ELEDO_ACCOUNT } from 'graphql/EledoAccountQueries';
import { useEffect, useState } from 'react'

const useEledoAccount = () => {
  const client = useApolloClient();
  
  const [ eledoAccount, setEledoAccount] = useState<EledoAccount>();

  const { loading, error, data } = useQuery<EledoAccountData, EledoAccountVars>(GET_ELEDO_ACCOUNT);
  
  useEffect(() => {
    if (loading || !data){
      return
    }

    const eledoAccount: EledoAccount = structuredClone(data.account)

    setEledoAccount(eledoAccount)

  }, [data, client, loading])

  return { loading, error, eledoAccount }
}

export const eledoAccountInput = (eledoAccount: EledoAccount | undefined): EledoAccountInput | undefined => {
  if(eledoAccount === undefined){
    return undefined
  }
  return {
    name: eledoAccount.name,
    locale: eledoAccount.locale,
    timezone: eledoAccount.timezone,
    language: eledoAccount.language,
    countryCode: eledoAccount.countryCode,
    profile: eledoProfileInput(eledoAccount.profile),
    notifications: eledoNotificationsConfigInput(eledoAccount.notifications)
  }
}

const eledoProfileInput = (eledoProfile: EledoAccountProfile | undefined): EledoAccountProfileInput | undefined => {
  if(eledoProfile === undefined){
    return undefined
  }
  return {
    properties: eledoProfile.properties.map((data => ({ key: data.key, value: data.value}))),
    counters: eledoProfile.counters.map((data => ({ key: data.key, value: data.value}))),
    autoActivate: eledoProfile.autoActivate
  }
}

const eledoNotificationsConfigInput = (eledoNotificationsConfig: EledoNotificationsConfig | undefined): EledoNotificationsConfigInput | undefined => {
  if(eledoNotificationsConfig === undefined){
    return undefined
  }
  return {
    warnLimit80: eledoNotificationsConfig.warnLimit80,
    warnLimit100: eledoNotificationsConfig.warnLimit100,
    paymentReceived: eledoNotificationsConfig.paymentReceived,
    paymentPDFAttachment: eledoNotificationsConfig.paymentPDFAttachment,
    paymentEmail: eledoNotificationsConfig.paymentEmail,
    opsEmail: eledoNotificationsConfig.opsEmail,
    monthlyReport: eledoNotificationsConfig.monthlyReport,
    helpdeskReply: eledoNotificationsConfig.helpdeskReply
  }
}

export default useEledoAccount